module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w540.9424e8a8.webp";